<template>
  <aside class="sidebar">
    <ul>
      <li v-for="(item, index) in menuItems" :key="index">
        <router-link :to="item.path">{{ item.title }}</router-link>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  name: "SideBar",
  props: {
    menuItems: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.sidebar {
  width: 200px;
  background-color: #34495e;
  color: white;
  padding: 1rem;
  overflow-y: auto;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar li {
  margin-bottom: 0.5rem;
}

.sidebar a {
  color: white;
  text-decoration: none;
  display: block;
  padding: 0.5rem;
  border-radius: 4px;
}

.sidebar a:hover {
  background-color: #2c3e50;
}

.sidebar .router-link-exact-active,
.sidebar .router-link-exact-active:hover,
.sidebar .router-link-active,
.sidebar .router-link-active:hover {
  background-color: #42b983;
  color: white;
}
</style>
